import { ReactNode } from 'react';

import { Flex, Box, Badge, Typography } from 'shared';
import { Icon } from 'shared_DEPRECATED/components/Icon';
import Spacer from 'shared_DEPRECATED/components/Spacer';
import { Nullable } from 'shared_DEPRECATED/types';
import { Picture } from 'shared_DEPRECATED/types/Picture';
import { dateUtils, getPictureUrl } from 'shared_DEPRECATED/utils';

import { ChallengeInfo } from 'features/challenge/components/Info';
import { getGoalDeadlineStyles } from 'features/goal/utils';

type TGoalNonRepeatedChallengeCard = {
  title: string;
  picture: Nullable<Picture>;
  emoji: Nullable<string>;
  children: ReactNode;
  completedDate: Nullable<string>;
  dueDate: string;
};

export const GoalNonRepeatedChallengeCard = ({
  title,
  picture,
  emoji,
  children,
  completedDate,
  dueDate,
}: TGoalNonRepeatedChallengeCard) => {
  const isDeadlineExpired = dateUtils.isCurrentDateAfterDate(dueDate);

  const { badgeColor, textColor, iconName, iconColor } = getGoalDeadlineStyles({
    isDeadlineExpired,
    isCompleted: !!completedDate,
  });

  return (
    <Box
      width="100%"
      backgroundColor="var(--bgCompPrimary)"
      borderRadius="var(--border-radius)"
    >
      <Spacer size="sm">
        <Flex width="100%" justifyContent="space-between" alignItems="center">
          <Flex>
            <ChallengeInfo
              emoji={emoji}
              pictureUrl={getPictureUrl(picture)}
              title={title}
              isCropped={false}
            >
              <Badge colorPalette={badgeColor}>
                <Flex alignItems="center" gap="var(--spacing01)">
                  <Icon name={iconName} fill={iconColor} />
                  <Typography
                    as="span"
                    type="small"
                    //@ts-ignore
                    color={textColor}
                    fontWeight="medium"
                    whiteSpace="nowrap"
                  >
                    {dateUtils(completedDate ? completedDate : dueDate).format(
                      'MMM D'
                    )}
                  </Typography>
                </Flex>
              </Badge>
            </ChallengeInfo>
          </Flex>
          {children}
        </Flex>
      </Spacer>
    </Box>
  );
};
